'use strict';

import get from 'lodash/get';
import { $http } from '../app.config';
import { africaOptions } from '../globals';
import { I18n } from '../helpers/i18n';
import Model from './Model';

export default class Contact extends Model {

    public name: string;
    public from: string;
    public phone: string;
    public message: string;

    constructor(data: { name?: string, from?: string, phone?: string, message?: string } = {}) {
        super(data);
        this.defineField('name', {
            type: 'String',
            validate: [
                {
                    validator: 'presence',
                    message: I18n.t('Please fill in the name'),
                },
            ],
        });
        this.defineField('from', {
            type: 'String',
            validate: [
                {
                    validator: 'stringEmail',
                    allowDisplayName: false,
                    allowUtf8LocalPart: false,
                    message: I18n.t('Your email is not valid'),
                },
            ],
        });
        this.defineField('phone', {
            type: 'String',
            validate: [],
        });
        this.defineField('message', {
            type: 'String',
            validate: [
                {
                    validator: 'presence',
                    message: I18n.t('Please fill in the mandatory fields'),
                },
            ],
        });
        this.populate(data);
    }

    public save(captcha?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            const route = africaOptions.api.routes.site.contact;
            const data: any = {
                contactForm: this.serialize(),
            };
            if (captcha) {
                data.captcha = captcha;
            }
            $http
                .post(route, data)
                .then((response) => {
                    if (get(response, 'data.errors', []).length > 0) {
                        reject(get(response, 'data.errors', []));
                    }
                    resolve(response.data);
                }, () => {
                    reject();
                });
        });
    }
}
